module.exports = __webpack_public_path__ + "src/assets/textures/env/ladder/ladder_512_bake.png";